export enum PorchRoofEndsStyle {
  TexwinEnclosedEnds = 'texwin_enclosed_ends',
  TexwinEnclosedSides = 'texwin_enclosed_sides',
}
